import { useRecoilState } from 'recoil';

import atoms from '@Components/Utilities/SandhillsAtoms';
import { loadable } from '@Components/Utilities/SandhillsLoadable';

const QuickSignUpModal = loadable(() => import('@Components/Shared/Modals/QuickSignUpModal'), true);

const LazyQuickSignUpModal = (props) => {
    const [showModal, setShowModal] = useRecoilState(atoms.showQsu);

    return (
        showModal && <QuickSignUpModal {...props} setShowModal={setShowModal} />
    );
};

export default LazyQuickSignUpModal;
global.LazyQuickSignUpModal = LazyQuickSignUpModal;